<template>
  <div class="locale-changer">
    <div
      class="selected-language"
      :class="{ 'is-open': isOpen }"
      @click="toggleDropdown"
    >
      <span class="current-lang">{{ $i18n.locale.toUpperCase() }}</span>
      <i class="dropdown-icon fa fa-chevron-down" />
    </div>
    <transition name="fade">
      <ul
        v-if="isOpen"
        class="language-dropdown"
      >
        <li
          v-for="lang in langs"
          :key="lang.code"
          :class="{ active: $i18n.locale === lang.code }"
          style="width: 100%"
        >
          <a
            href="#"
            @click="changeLanguage(lang.code, $event)"
          >
            <i :class="'flag-icon flag-icon-' + lang.flag" />
            <span>{{ lang.name }}</span>
          </a>
        </li>
      </ul>
    </transition>
  </div>
</template>


<script>
export default {
  name: 'LocaleChanger',
  data() {
    return {
      isOpen: false,
      langs: [
        { code: 'en', name: 'English', flag: 'gb-eng' },
        { code: 'az', name: 'Azərbaycan', flag: 'az' },
        { code: 'ru', name: 'Pусский', flag: 'ru' }
      ]
    };
  },
  mounted() {
    // Close dropdown when clicking outside
    document.addEventListener('click', this.closeDropdown);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closeDropdown);
  },
  methods: {
    toggleDropdown(event) {
      event.stopPropagation();
      this.isOpen = !this.isOpen;
    },
    closeDropdown(event) {
      // Only close if click is outside the component
      if (!this.$el.contains(event.target)) {
        this.isOpen = false;
      }
    },
    changeLanguage(lang, event) {
      event.preventDefault();
      localStorage.setItem('userLang', lang); // Store selected language in localStorage
      this.$i18n.locale = lang;
      this.isOpen = false;
      window.location.reload();
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/theme/_variables.scss";

.locale-changer {
  position: relative;
  display: inline-block;
  user-select: none;
}

.selected-language {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: $btn-border-radius;
  background-color: rgba($primary-color, 0.1);
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba($primary-color, 0.2);
  }

  &.is-open {
    background-color: rgba($primary-color, 0.25);
    box-shadow: 0 0 0 2px rgba($primary-color, 0.2);

    .dropdown-icon {
      transform: rotate(180deg);
    }
  }

  .current-lang {
    font-weight: 600;
    color: $primary-color;
    margin-right: 8px;
    font-size: 14px;
  }

  .dropdown-icon {
    font-size: 12px;
    color: $primary-color;
    transition: transform 0.3s ease;
  }
}

.language-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  min-width: 160px;
  background-color: $white;
  border-radius: $card-border-radious;
  box-shadow: $card-box-shadow;
  padding: 8px 0;
  z-index: 1000;
  list-style-type: none;

  li {
    margin: 0;
    padding: 0;

    &.active a {
      background-color: rgba($primary-color, 0.15);
      color: $primary-color;
      font-weight: 600;
    }

    a {
      display: flex;
      align-items: center;
      padding: 10px 16px;
      color: $theme-body-font-color;
      text-decoration: none;
      transition: all 0.2s ease;
      width: 100%;

      &:hover {
        background-color: rgba($primary-color, 0.1);
        color: $primary-color;
      }

      .flag-icon {
        margin-right: 10px;
        width: 20px;
        height: 15px;
        object-fit: contain;
        transition: transform 0.2s ease;
      }

      &:hover .flag-icon {
        transform: scale(1.15);
      }

      span {
        font-size: 14px;
      }
    }
  }
}

// Transition effects
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

// Responsive adjustments
@media (max-width: 768px) {
  .selected-language {
    padding: 6px 10px;

    .current-lang {
      font-size: 13px;
    }
  }

  .language-dropdown {
    min-width: 140px;

    li a {
      padding: 8px 12px;

      span {
        font-size: 13px;
      }
    }
  }
}

@media (max-width: 480px) {
  .language-dropdown {
    right: -10px; // Adjust position to prevent overflow on small screens
  }
}
</style>
